import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminProtectedRoute = () => {

  const token = localStorage.getItem('token');
  const adminName = localStorage.getItem('adminName');

  // ✅ 1. Agar Token nahi hai, to SECRET login page par bhejo
  if (!token) {
    // ❌ Purana: return <Navigate to="/admin/login" replace />;
    
    // ✅ Naya (Apna Secret Path yahan likho):
    return <Navigate to="/win11-control-room/login" replace />;
  }

  // ✅ 2. Agar Token hai par Admin Name nahi hai (Matlab Normal User hai)
  if (!adminName) {
    alert("Access Denied: You are not an Admin!");
    
    // Yahan home page ('/') par bhejna zyada safe hai
    // taaki normal user ko login page ka bhanak na lage
    return <Navigate to="/" replace />; 
  }

  return <Outlet />;
};

export default AdminProtectedRoute;